import { render, staticRenderFns } from "./VotingPanel.vue?vue&type=template&id=746cc4be&scoped=true"
import script from "./VotingPanel.vue?vue&type=script&lang=js"
export * from "./VotingPanel.vue?vue&type=script&lang=js"
import style0 from "./VotingPanel.vue?vue&type=style&index=0&id=746cc4be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746cc4be",
  null
  
)

export default component.exports